// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { rem } from 'polished';

//  Little javascript method to get initials from a name
// eslint-disable-next-line
String.prototype.getInitials = function(glue) {
	if (typeof glue === 'undefined') {
		glue = true;
	}

	const initials = this.replace(/[^a-zA-Z0-9- ]/g, '').match(/\b\w/g);

	if (glue && initials) {
		return initials.join('');
	}

	return this;
};
// eslint-disable-next-line
String.prototype.capitalize = function() {
	return this.toLowerCase().replace(/\b\w/g, m => m.toUpperCase());
};

/**********
 ** Component: TeamAvatar
 ** @type: functional stateless component
 ** @description:  componentDescription
 **********/
const TeamAvatar = props => {
	let teamNameInitials = `${props.nick}`.getInitials().substring(0, 3);
	return (
		<Wrapper large={props.large}>
			<div className="team">
				<h5 className="team__initials">{`${teamNameInitials}`}</h5>
			</div>
		</Wrapper>
	);
};

const Wrapper = styled.div`
	width: ${props => (props.large ? `${rem('96px')}` : `${rem('32px')}`)};
	height: ${props => (props.large ? `${rem('96px')}` : `${rem('32px')}`)};
	border-radius: ${props => (props.large ? `${rem('96px')}` : `${rem('32px')}`)};
	display: flex;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;

	@media ${props => props.theme.breakpointLarge} {
		width: ${props => (props.large ? `${rem('138px')}` : `${rem('48px')}`)};
		height: ${props => (props.large ? `${rem('138px')}` : `${rem('48px')}`)};
		border-radius: ${props => (props.large ? `${rem('138px')}` : `${rem('48px')}`)};
	}

	.team,
	.team__initials {
		width: 100%;
		height: 100%;
		border-radius: ${props => (props.large ? `${rem('68px')}` : `${rem('32px')}`)};
		@media ${props => props.theme.breakpointLarge} {
			border-radius: ${props => (props.large ? `${rem('138px')}` : `${rem('48px')}`)};
		}
		margin: 0;
		padding: 0;
		background-color: ${props => props.theme.primaryColor};
		color: ${props => props.theme.white};
		font-size: ${props => (props.large ? `${rem('32px')}` : `${rem('14px')}`)};
		font-weight: 400;
		letter-spacing: 1.25px;
		text-align: center;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;

		@media ${props => props.theme.breakpointLarge} {
			font-weight: 600;
			font-size: ${props => (props.large ? `${rem('60px')}` : `${rem('18px')}`)};
		}

		@media ${props => props.theme.breakpointXxlarge} {
			font-weight: 600;
			font-size: ${props => (props.large ? `${rem('60px')}` : `${rem('22px')}`)};
		}
	}
`;

TeamAvatar.defaultProps = {
	nick: 'Aa',
};

TeamAvatar.propTypes = {
	large: PropTypes.bool,
	nick: PropTypes.string,
};

export default TeamAvatar;



// WEBPACK FOOTER //
// ./src/components/ui/layout/team-avatar/index.jsx